import React from 'react';

import { TelepresencePurchaseCard } from '../TelepresencePurchaseCard/TelepresencePurchaseCard';
import { Carousel } from 'react-bootstrap';
import { UseSliceContentBreakpoint } from '../../../Core/Hooks/HooksGenerals/UseSliceContentBreakpoint';
import useIsMobile from '../../../Core/Hooks/HooksGenerals/UseIsMobile';

export const TelepresencePurchase = ({ props, scheduler = [], modeId, parameters }) => {
  const { slicedContentList } = UseSliceContentBreakpoint(scheduler);
  const isMobile = useIsMobile();

  const RenderCarousel = () => (
    <Carousel controls={null} className="control-dark">
      {slicedContentList.map((content, index) => (
        <Carousel.Item key={index}>
          <div className="d-flex gap-3 justify-content-md-end justify-content-center pb-3 py-2 my-2">
            {content?.map((schedulerInfo, idx) => (
              <TelepresencePurchaseCard
                props={props}
                key={schedulerInfo.id}
                index={isMobile ? index : idx}
                hideIndex={isMobile ? slicedContentList.length <= 1 : content.length <= 1}
                isMobile={isMobile}
                {...{
                  parameters: parameters,
                  schedulerInfo
                }}
                badgeImage={props?.badgeImage}
                modeId={modeId}
                changeView={props.changeView}
                showEnrrolmentForm={props.showEnrrolmentForm}
                setShowEnrrolmentForm={props.setShowEnrrolmentForm}
                handleUpdateMemberships={props.handleUpdateMemberships}
                membershipListIdScheduler={props.membershipListIdScheduler}
                language={props.language}
              />
            ))}
          </div>
        </Carousel.Item>
      ))}
    </Carousel>
  );

  return (
    <div className="d-flex gap-3  justify-content-center pb-3 py-2 my-2">
      {scheduler?.length === 0 ? (
        <TelepresencePurchaseCard
          className="mx-auto text-center"
          parameters={parameters}
          badgeImage={props?.badgeImage}
          disabled
        />
      ) : (
        <RenderCarousel />
      )}
    </div>
  );
};
